export enum ContactType {
  BILLING = 'BILLING',
  HR = 'HR',
  SURECO = 'SURECO',
  BROKER = 'BROKER',
}
